import type { Board } from '@trello/model-types';

export const allowsSelfJoin = (board: {
  prefs?: Pick<Board['prefs'], 'selfJoin' | 'isTemplate'> | null;
}) => {
  return (board.prefs?.selfJoin ?? false) && !board.prefs?.isTemplate;
};
